<template lang="html">
  <pl-dialog
    :header="'What kind of Roundtable?'"
    :headerStyle="'font-weight: bold; font-size: 24px;'"
    :maxWidth="'900px'"
    :maxHeight="'610px'"
    :height="'453px'"
    :padding="'2em'"
    @close="$emit('close')"
    class=""
  >
    <section
      key="live-online"
      class="choose-universe-live-online h-auto flex flex-wrap"
    >
      <div class="flex-grow tc pt4">
        <div
          @click="createPremade('online')"
          class="ma3 grow justify-center choose-activity-btn clickable"
        >
          <img
            src="/static/online_roundtable_icons/online.svg"
            alt="written roundtable"
            style="height: 95px"
          />
          <div class="b mt3 f4">Written</div>
          <div class="pl-caption pv2 mv2">
            A tool for written blended discussions and collaboration.
          </div>
          <div class="pill-online pl-caption">Create Written RoundTable</div>
        </div>
      </div>
      <div class="flex-grow tc pt4">
        <div
          @click="createPremade('live')"
          class="ma3 grow justify-center choose-activity-btn clickable"
        >
          <img
            src="/static/live_discussion/live.svg"
            alt="verbal discussion"
            style="height: 95px"
          />
          <div class="b mt3 f4">Verbal</div>
          <div class="pl-caption pv2 mv2">
            A tool for facilitating and tracking face-to-face discussions.
          </div>
          <div class="pill-live pl-caption">Create Verbal RoundTable</div>
        </div>
      </div>
    </section>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import premadeServices from 'services/premades/premadeServices';

  export default {
    data() {
      return {
        show_create_premade_modal: false,
      };
    },
    components: {},
    computed: {
      ...mapGetters([]),
    },
    methods: {
      createPremade(type) {
        premadeServices.createNewPremade(type).then(({ data }) => {
          if (type === 'live') {
            this.$router.push({
              name: 'live-premade-form',
              params: {
                premadeID: data.id,
              },
            });
          } else {
            this.$router.push({
              name: 'premade-form',
              params: {
                premadeID: data.id,
              },
            });
          }
        });
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  // *
  //   outline: 1px solid red
  .ruby
    color: pl-ruby
  .choose-activity-btn
    width: 250px;
    margin: 2em auto;
    padding: 2em 1em;
    &:hover
      box-shadow: 2px 2px 16px 4px rgba( 0, 0, 0, 0.2 );
  .pill-online
    border: 2px solid #78BEC8
    border-radius: 2em
    align-self: center
    padding: 0.5em 1em
    color: #78BEC8
    font-weight: bold
    background-color: #EAF8F9
  .pill-live
    border: 2px solid #5FA95C
    border-radius: 2em
    align-self: center
    padding: 0.5em 1em
    color: #5FA95C
    font-weight: bold
    background-color: #E8F8E7
  .choose-activity-appear-enter-only-enter-active
    transition: all .6s ease
  .choose-activity-appear-enter-only-leave-active
    display: none
  .choose-activity-appear-enter-only-enter, .choose-activity-appear-enter-only-leave-to
    opacity: 0
</style>



// WEBPACK FOOTER //
// createPremadeModal.vue?5a80a84e